import { connect } from 'react-redux';
import CASHPIE from './CASHPIE';

import { getAnnualResults } from '../../selectors';
import { selectTotalkWh } from '../../../../../common/utility/selectors';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    projectState: state.projectaddress.projectState,
    aFixedCharge: state.utility.aFixedCharge,
    annualMonth: state.settings.annualMonth,
    totalkWhs: selectTotalkWh(state),
    includeESS: state.ess.includeESS,
    sgipToggle: state.sgip.sgipToggle,
    resiToggle: state.tax.resiToggle,
});

const combinedActions = {};

export default connect(
    mapStateToProps,
    combinedActions,
)(CASHPIE);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/CASHPIE/index.js